import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import AccessDeniedVinci from './AccessDeniedVinci';
import { connect } from 'react-redux';
import { getUor } from 'store/selectors';

class AccessDenied extends Component {
  render() {
    const { t, uor } = this.props

    switch(uor) {
      case 735:
      case '735':
        return <AccessDeniedVinci />
      default:
        return (
          <div>
            <p>{t('access.denied')}</p>
            <p>
              <a href="https://portal.eleneo.fr/">{t('access.backToPortal')}</a>
            </p>
          </div>
        )

    }
  }
}

const mapStateToProps = (state) => ({
  uor: getUor(state),
})

export default withTranslation()(connect(mapStateToProps)(AccessDenied))
